<template>
    <div :id="`content-gallery-${data?.id}`" class="content-gallery">
        <div v-if="!!data?.gallery.length" class="content-gallery--grid" :class="[data?.columns]">
            <div v-for="item in data?.gallery" :key="item.id" class="page-media">
                <UiImage :src="item.webp" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
